export default __webpack_public_path__ + "static/media/error-icon.7d529581.svg";